const colorUtils = {
    hexToRgb(fill) {
       fill = fill.replace('#', '');
       var hex = parseInt(fill, 16);

        var r = hex >> 16;
        var g = hex >> 8 & 0xFF;
        var b = hex & 0xFF;

        return {r, g, b};
    },
    hexToMatrix(hex) {
        var rgb = this.hexToRgb(hex);
        var matrix = '';

        matrix = matrix + '0 0 0 0 ' + (rgb.r / 255);
        matrix = matrix + ' 0 0 0 0 ' + (rgb.g / 255);
        matrix = matrix + ' 0 0 0 0 ' + (rgb.b / 255);
        matrix = matrix + ' 1 1 1 1 0';

        return matrix;
    }
};

export default colorUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ColorUtils.js
 **/